export const parseDateSafely = (dateString: string): Date => {
  if (!dateString) {
    return new Date()
  }

  const year = parseInt(dateString.slice(0, 4))
  const month = parseInt(dateString.slice(5, 7)) - 1
  const day = parseInt(dateString.slice(8, 10))

  if (dateString.length > 10) {
    const timePart = dateString.slice(11)
    const [hours, minutes, seconds] = timePart.split(':').map(Number)
    return new Date(year, month, day, hours || 0, minutes || 0, seconds || 0)
  }

  return new Date(year, month, day)
}

export const getNumberDayOfCurrentMonth = (monthName: string): number => {
  switch (monthName) {
    case 'January':
      return 0
    case 'February':
      return 1
    case 'March':
      return 2
    case 'April':
      return 3
    case 'May':
      return 4
    case 'June':
      return 5
    case 'July':
      return 6
    case 'August':
      return 7
    case 'September':
      return 8
    case 'October':
      return 9
    case 'November':
      return 10
    case 'December':
      return 11
    default:
      return 4
  }
}

export const getDaysInMonth = (year: number, month: number) => {
  return 32 - new Date(year, month, 32).getDate()
}

export const fillingArray = (
  n: number,
  m: number,
  id: number,
  monthNumber: number,
  startDateString: string,
  endDateString: string,
  year = Number(startDateString.slice(0, 4)),
) => {
  const daysInMonth = getDaysInMonth(year, monthNumber)
  const arr: number[] = []

  const startYear = Number(startDateString.slice(0, 4))
  const startMonth = Number(startDateString.slice(5, 7)) - 1
  const endYear = Number(endDateString.slice(0, 4))
  const endMonth = Number(endDateString.slice(5, 7)) - 1

  const viewMonthStart = new Date(year, monthNumber, 1)
  const viewMonthEnd = new Date(year, monthNumber, daysInMonth)
  const bookingStart = new Date(startYear, startMonth, n)
  const bookingEnd = new Date(endYear, endMonth, m)

  if (bookingEnd < viewMonthStart || bookingStart > viewMonthEnd) {
    return { arr, id }
  }

  const startDay = bookingStart < viewMonthStart ? 1 : n
  const endDay = bookingEnd > viewMonthEnd ? daysInMonth : m

  for (let i = startDay; i <= endDay; i++) {
    arr.push(i)
  }

  return { arr, id }
}
